import { identity } from 'ramda';
import React, { useEffect, useState } from 'react';
import { getHtmlElUID } from '../../../utils/helpers';
import Loading from '../Loading/Loading';
import './Button.scss';

const Button = (props) => {
  const [isBusy, setIsBusy] = useState(false);

  const {
    busy = false,
    classNames = [],
    onClick = () => {},
    text = null,
    type = 'button',
    size = 'medium',
    appearance = 'primary',
    stretch = false,
    shrank = false,
    jelly = false,
    isNew = false,
    disabled = false,
    icon = null,
    description = null,
    onKeyDown = () => {},
    ...rest
  } = props;

  const descUID = getHtmlElUID('app-btn-aria-desc');

  const innerClassNames = isNew
    ? [
        `app-btn-appear-${appearance}`,
        appearance !== 'disabled' && disabled ? `app-btn-appear-disabled` : null,
        `app-btn-size-${size}`,
        stretch ? 'app-btn-stretched' : null,
        shrank ? 'app-btn-shrank' : null,
        jelly ? 'app-btn-jelly' : null,
      ].filter(identity)
    : [];

  const onClickProxy = (e) => {
    onClick(e);
    type === 'submit' ? void 0 : e.preventDefault();
  };

  const onKeyDownProxy = (e) => {
    onKeyDown(e);
    if (e && e.isDefaultPrevented()) {
      return;
    }
    switch (e.key) {
      case 'Enter':
        onClickProxy(e);
        break;
    }
  };

  const getIcon = () => {
    return icon ? <i className={`far fa-${icon}`}></i> : void 0;
  };

  const getText = () => {
    return text ? <span>{text}</span> : void 0;
  };

  const getAriaDescription = () => {
    return description ? (
      <span id={descUID} hidden>
        {description.replace(/\s+/g, ' ')}
      </span>
    ) : (
      void 0
    );
  };

  useEffect(() => {
    setIsBusy(busy);
  }, [busy]);

  return (
    <button
      type={type}
      className={['app-button', isBusy ? 'app-button-busy' : null, ...innerClassNames, ...classNames]
        .filter(identity)
        .join(' ')}
      disabled={isBusy || appearance === 'disabled' || disabled}
      onClick={onClickProxy}
      onKeyDown={onKeyDownProxy}
      {...(description ? { 'aria-describedby': descUID } : {})}
      {...rest}>
      {isBusy ? <Loading show classNames={['app-button-loading']} /> : void 0}
      {getIcon()}
      {icon && text ? ' ' : void 0}
      {getText()}
      {getAriaDescription()}
    </button>
  );
};

export default Button;
